import gql from 'graphql-tag'
import axios from 'axios'
import api from '../apiClient'
import { NotificationStore } from '@/components/vueblack/NotificationPlugin'

export default {
  list: () =>
    api
      .send({
        query: gql`
          query documentoExoneracion {
            TYPES {
              Exoneracion {
                readAll {
                  id
                  value
                  annotation
                }
              }
            }
          }
        `
      })
      .then(result => result.data.data.TYPES.Exoneracion.readAll),

  exonet: async autorizacion => {
    const url = `https://api.hacienda.go.cr/fe/ex?autorizacion=${autorizacion}`

    return axios.get(url).then(result => {
      if (result.status !== 200) {
        NotificationStore.notify({
          type: 'danger',
          message: 'Ha ocurrido un error al comprobar el número de documento en EXONET',
          icon: 'fa fa-cloud-showers-heavy'
        })
        return Promise.reject(new Error('error'))
      }

      return result.data
    })
  }
}
